import { createAction } from 'redux-act';
import { paramsForServer } from 'feathers-hooks-common';
//
import { KEYS } from 'utils/constants';
import { SchoolClassService } from 'services';
import { showErrorNotification } from 'utils/error-handlers';
import { setLoading } from '../loading/actions';
import { showNotification } from '../../utils/appUtils';
import { apolloClient } from 'meeopp-graphql/apollo-client';
import { STAFF_SCHOOL_CLASSES } from '../../graphql/modules/school-classes';
import { USER_TYPES_MAP } from '../../utils/constants';

export const fetchStaffSchoolClassesSuccess = createAction('fetchStaffSchoolClassesSuccess');
export const clearSchoolClassStateSuccess = createAction('clearSchoolClassStateSuccess');
export const fetchSchoolClassSuccess = createAction('fetchSchoolClassSuccess');
export const patchSchoolClassSuccess = createAction('patchSchoolClassSuccess');
export const setSchoolClassStudents = createAction('setSchoolClassStudents');

export const clearSchoolClassState = () => {
  return (dispatch) => {
    dispatch(
      setLoading({
        key: KEYS.clearSchoolClassState,
        value: true,
      })
    );

    dispatch(clearSchoolClassStateSuccess());

    dispatch(
      setLoading({
        key: KEYS.clearSchoolClassState,
        value: false,
      })
    );
  };
};

export const fetchStaffSchoolClasses = (user) => {
  return async (dispatch) => {
    if (user.userType !== USER_TYPES_MAP.schoolStaff) {
      dispatch(fetchStaffSchoolClassesSuccess({ data: [] }));
      return;
    }

    const loadingObj = {
      key: KEYS.fetchStaffSchoolClasses,
      value: true,
    };

    dispatch(setLoading(loadingObj));

    try {
      const { data } = await apolloClient.query({
        query: STAFF_SCHOOL_CLASSES,
        fetchPolicy: 'network-only',
      });

      const schoolClasses = data.staffSchoolClasses;
      dispatch(fetchStaffSchoolClassesSuccess({ data: schoolClasses }));
    } catch (e) {
      showErrorNotification();
    }

    loadingObj.value = false;
    dispatch(setLoading(loadingObj));
  };
};

export const fetchSchoolClass = (_id) => {
  return async (dispatch) => {
    if (!_id) {
      dispatch(fetchSchoolClassSuccess(null));
      return;
    }

    const loadingObj = {
      key: KEYS.fetchSchoolClass,
      value: true,
    };

    dispatch(setLoading(loadingObj));
    try {
      const schoolClass = await SchoolClassService.get(
        _id,
        paramsForServer({
          action: 'fill-students',
        })
      );

      dispatch(fetchSchoolClassSuccess(schoolClass));
    } catch (e) {
      showErrorNotification();
    }

    loadingObj.value = false;
    dispatch(setLoading(loadingObj));
  };
};

// This action should only be accessible by MeeOpp Staff
export const patchSchoolClass = (schoolClassId, data, action) => {
  return async (dispatch) => {
    const loadingObj = {
      key: KEYS.patchSchoolClass,
      value: true,
    };

    dispatch(setLoading(loadingObj));

    try {
      const params = {};
      if (action) params.action = action;

      const schoolClass = await SchoolClassService.patch(
        schoolClassId,
        data,
        paramsForServer(params)
      );

      dispatch(patchSchoolClassSuccess(schoolClass));
      showNotification('success', 'Success');
    } catch (e) {
      showErrorNotification(e.message);
    }

    loadingObj.value = false;
    dispatch(setLoading(loadingObj));
  };
};

export const addStudentsToClass = (schoolClassId, studentIdsToAdd) => {
  return async (dispatch) => {
    const loadingObj = {
      key: KEYS.patchSchoolClass,
      value: true,
    };

    dispatch(setLoading(loadingObj));

    try {
      const schoolClass = await SchoolClassService.patch(
        schoolClassId,
        {
          studentIdsToAdd,
        },
        paramsForServer({
          action: 'add-students-to-class',
        })
      );

      dispatch(patchSchoolClassSuccess(schoolClass));
    } catch (e) {
      showErrorNotification(e.message);
    }

    loadingObj.value = false;
    dispatch(setLoading(loadingObj));
  };
};
